import { useField } from 'formik';
import { useCallback, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const INPUT_DELAY = 200;

export function useTextField(name) {
  const [field, meta, helpers] = useField(name);
  const [innerValue, setInnerValue] = useState('');
  const { error, touched } = meta;
  const { setValue, setTouched } = helpers;

  useEffect(() => {
    if (field.value) {
      setInnerValue(field.value);
    } else {
      setInnerValue(undefined);
    }
  }, [field.value]);

  const { onBlur } = field;

  const handleBlur = (event) => {
    onBlur(event);
    setTouched(true, true);
  };

  const debounced = useDebouncedCallback(
    (value) => {
      setValue(value);
    },
    INPUT_DELAY,
  );

  const hasError = Boolean(error && touched);

  const handleOnChange = useCallback((event) => {
    const isEvent = Boolean(event?.target);
    if (isEvent) {
      event.persist();
      setInnerValue(event.currentTarget.value);
      debounced(event.target.value);
    } else {
      setInnerValue(event);
      debounced(event || undefined);
    }
  }, [debounced]);

  return [
    innerValue,
    {
      handleOnChange,
      hasError,
      handleBlur,
      error,
    },
  ];
}
